import * as PropTypes from "prop-types";
import {connect} from "react-redux";
import {DetailValue} from "@mc/mc-legacy";
import {Component} from "react";
import * as React from "react";
import {CardBody, Col, Row} from "reactstrap";
import {formatDateTime} from "../utils/utils";
import StavObjednavka from "./StavObjednavka";
import {Link} from "react-router-dom";
import ObjednavkyUrlFactory from "../api/ObjednavkyUrlFactory";
import TextTruncate from 'react-text-truncate';
import {withTranslation, WithTranslation} from "react-i18next";

/**
 * Panel s údaji objednávky pro zobrazení v seznamu.
 */
class ObjednavkaListPanel extends Component<WithTranslation> {

    static propTypes = {
        objednavka: PropTypes.object.isRequired, // data objednávky (ObjednavkaVO)
    };

    render() {
        const {t} = this.props;

        const objednavka = this.props.objednavka;
        const pocetSouboru = objednavka.pocetSouboru || 0;
        const muzuVidetCenu = objednavka.viewObjCena;
        const muzuVidetPoznamkuInterni = objednavka.viewPoznamkaInterni;
        const cenaBezDph = muzuVidetCenu && objednavka.celkemBezDph ? `${objednavka.celkemBezDph} ${t('currency_symbol')}` : "-";
        const cenaSDph = muzuVidetCenu && objednavka.celkemSDph ? `${objednavka.celkemSDph} ${t('currency_symbol')}` : "-";
        const poznamkaInterni = objednavka.poznamkaInterni ?
            <Col md={1} title={objednavka.poznamkaInterni}>
                <DetailValue label={t('order.internal_note')}>
                    <TextTruncate
                        line={1}
                        truncateText="…"
                        text={objednavka.poznamkaInterni} />
                </DetailValue>
            </Col> :
            <Col md={1}><DetailValue label={t('order.internal_note')}>-</DetailValue></Col>;
        return <CardBody className="objednavka-list-panel">
            <Row>
                <Col md={12}>
                    <Link className="row-header flex-nowrap" to={ObjednavkyUrlFactory.objednavkaDetail(objednavka.id)}>
                        {`${t('order.one')}: ${objednavka.cisloObjednavka} - ${formatDateTime(objednavka.datumVyzvedDoruc, null, "DD.MM.YYYY")}${objednavka.casVyzvedDoruc ? ' ' + objednavka.casVyzvedDoruc : ''}`}
                    </Link>
                </Col>
            </Row>
            <Row>
                <Col>
                    <DetailValue label={t('state')}><StavObjednavka stav={objednavka.stavObjednavka} /></DetailValue>
                </Col>
                <Col>
                    <DetailValue label={t('firstname_and_surname')}>{objednavka.uzivatelObjednalJmeno}</DetailValue>
                </Col>
                <Col>
                    <DetailValue label={t('company')}>{objednavka.nazevSpolecnost}</DetailValue>
                </Col>
                <Col>
                    <DetailValue label={t('files_count')}>{pocetSouboru}</DetailValue>
                </Col>
                <Col>
                    <DetailValue label={t('order.name')}>{objednavka.naklStredObjednavka}</DetailValue>
                </Col>
                <Col>
                    <DetailValue label={t('order.price')}>{cenaBezDph}</DetailValue>
                </Col>
                <Col>
                    <DetailValue label={t('order.price_including_vat')}><b>{cenaSDph}</b></DetailValue>
                </Col>
                {muzuVidetPoznamkuInterni && poznamkaInterni}
            </Row>
        </CardBody>
    }
}

export default connect()(withTranslation()(ObjednavkaListPanel));
